import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ASAP_FRACIONADOS } from "app/auth/baseAsapFracionados";
import moment from "moment";
import constants from "@tracking/utils/constants";

const { DATE_FORMAT } = constants;

const parseGetFiliaisTransportadoras = (params) => {
  return {
    dataInicial: moment(params.dataInicial).format(DATE_FORMAT.API),
    dataFinal: moment(params.dataFinal).format(DATE_FORMAT.API),
  };
};

const parseGetRoteirosAlertas = (params) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasCnpjs: params.transportadorasCnpjs,
    regioes: params.regioes,
    dataCarteira: moment(params.dataCarteira).format(DATE_FORMAT.API),
  };
};

const parseGetRoteirosCriticidade = (params: any) => {
  return {
    filiaisIds: params.filiaisIds,
    transportadorasCnpjs: params.transportadorasCnpjs,
    regioes: params.regioes,
    dataCarteira: moment(params.dataCarteira).format(DATE_FORMAT.API),
    tipoCriticidade: params.tipoCriticidade,
  };
};

export const getFiliaisTransportadoras = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getFiliaisTransportadoras",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/roteiros/fracionados/pedidos/gruposefiliais",
        {
          params: parseGetFiliaisTransportadoras(params),
        }
      );
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);

export const getTransportadoras = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getTransportadoras",
  async () => {
    try {
      const response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/fracionados/transportadoras"
      );
      return response.data.transportadoras || [];
    } catch (err: any) {
      console.error("Erro ao buscar transportadoras:", err.response);
      throw err;
    }
  }
);

export const getFiliais = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getFiliais",
  async () => {
    try {
      const response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/fracionados/filiais"
      );
      return response.data.filiais || [];
    } catch (err: any) {
      console.error("Erro ao buscar filiais:", err.response);
      throw err;
    }
  }
);

export const getSafraDiaPedidos = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getSafraDiaPedidos",
  async (params: object) => {
    console.log("getSafraDiaPedidos params:", params);
    try {
      const response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/safra/dia/fracionados/pedidos",
        {
          params: parseGetRoteirosAlertas(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
      console.log("getSafraDiaPedidos response:", response?.data);
      return response.data;
    } catch (err: any) {
      console.error("Erro ao buscar safra dia pedidos:", err.response);
      throw err; // Lança o erro para o Redux Toolkit marcar como rejected
    }
  }
);

export const getRoteirosAlertas = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getRoteirosAlertas",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/roteiros/fracionados/alertas",
        {
          params: parseGetRoteirosAlertas(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);

export const getRoteirosCriticidade = createAsyncThunk(
  "torreFracionadosApp/torreFracionados/getRoteirosCriticidade",
  async (params: object) => {
    let response;
    try {
      response = await API_ASAP_FRACIONADOS.get(
        "/dashboard/roteiros/fracionados/criticidades",
        {
          params: parseGetRoteirosCriticidade(params),
          paramsSerializer: {
            indexes: null,
          },
        }
      );
    } catch (err: any) {
      console.error(err.response);
    }
    return response.data;
  }
);
